import * as AT from "./actionTypes";
import * as MT from "./mutationTypes";
import { ImportExportService } from "../services";
export default {
  [AT.STORE_STATES]: (context, data) => {
    context.commit(MT.SET_STATES, data);
  },
  [AT.STORE_CITIES]: (context, data) => {
    context.commit(MT.SET_CITIES, data);
  },
  [AT.STORE_UNITS]: (context, data) => {
    context.commit(MT.SET_UNITS, data);
  },
  [AT.STORE_ACCESSORIES]: (context, data) => {
    context.commit(MT.SET_ACCESSORIES, data);
  },
  [AT.STORE_ACCESSORIES]: (context, data) => {
    context.commit(MT.SET_ACCESSORIES, data);
  },
  [AT.STORE_CESS]: (context, data) => {
    context.commit(MT.SET_CESS, data);
  },
  [AT.STORE_CESS_GENERAL_DUTY]: (context, data) => {
    context.commit(MT.SET_CESS_GENERAL_DUTY, data);
  },
  [AT.STORE_CONTAINER_SEAL_TYPES]: (context, data) => {
    context.commit(MT.SET_CONTAINER_SEAL_TYPES, data);
  },
  [AT.STORE_CONTAINER_SIZES]: (context, data) => {
    context.commit(MT.SET_CONTAINER_SIZES, data);
  },
  [AT.STORE_CONTAINER_TYPES]: (context, data) => {
    context.commit(MT.SET_CONTAINER_TYPES, data);
  },
  [AT.STORE_COUNTRIES]: (context, data) => {
    context.commit(MT.SET_COUNTRIES, data);
  },
  [AT.STORE_DISTRICT_CODES]: (context, data) => {
    context.commit(MT.SET_DISTRICT_CODES, data);
  },
  [AT.STORE_DOCUMENT_TYPE_CODES]: (context, data) => {
    context.commit(MT.SET_DOCUMENT_TYPE_CODES, data);
  },
  [AT.STORE_CURRENCIES]: (context, data) => {
    context.commit(MT.SET_CURRENCIES, data);
  },
  [AT.STORE_DECLARATIONS]: (context, data) => {
    context.commit(MT.SET_DECLARATIONS, data);
  },
  [AT.STORE_RODTEPS]: (context, data) => {
    context.commit(MT.SET_RODTEPS, data);
  },
  [AT.STORE_END_USES]: (context, data) => {
    context.commit(MT.SET_END_USES, data);
  },
  [AT.STORE_EXPORTER_TYPES]: (context, data) => {
    context.commit(MT.SET_EXPORTER_TYPES, data);
  },
  [AT.STORE_EXPORT_UNDERS]: (context, data) => {
    context.commit(MT.SET_EXPORT_UNDERS, data);
  },
  [AT.STORE_GOODS_STUFFED_AT]: (context, data) => {
    context.commit(MT.SET_GOODS_STUFFED_AT, data);
  },
  [AT.STORE_GST_IN_TYPES]: (context, data) => {
    context.commit(MT.SET_GST_IN_TYPES, data);
  },
  [AT.STORE_IGST_PAYMENT_STATUS]: (context, data) => {
    context.commit(MT.SET_IGST_PAYMENT_STATUS, data);
  },
  [AT.STORE_NATURE_OF_CARGO]: (context, data) => {
    context.commit(MT.SET_NATURE_OF_CARGO, data);
  },
  [AT.STORE_SEAL_TYPES]: (context, data) => {
    context.commit(MT.SET_SEAL_TYPES, data);
  },
  [AT.STORE_SHIPMENT_TYPES]: (context, data) => {
    context.commit(MT.SET_SHIPMENT_TYPES, data);
  },
  [AT.STORE_SHOW_FOB_INS]: (context, data) => {
    context.commit(MT.SET_SHOW_FOB_INS, data);
  },
  [AT.STORE_SHOW_NATURE_OF_PAYMENTS]: (context, data) => {
    context.commit(MT.STORE_SHOW_NATURE_OF_PAYMENTS, data);
  },
  [AT.STORE_TERMS_OF_INVOICES]: (context, data) => {
    context.commit(MT.SET_TERMS_OF_INVOICES, data);
  },
  [AT.STORE_UNIT_PRICE_INCLUDES]: (context, data) => {
    context.commit(MT.SET_UNIT_PRICE_INCLUDES, data);
  },
  [AT.STORE_RITC_CODES]: (context, data) => {
    context.commit(MT.SET_RITC_CODES, data);
  },
  [AT.STORE_EXIM_SCHEME_CODES]: (context, data) => {
    context.commit(MT.SET_EXIM_SCHEME_CODES, data);
  },
  [AT.STORE_FOREIGN_PORTS]: (context, data) => {
    context.commit(MT.SET_FOREIGN_PORTS, data);
  },
  [AT.STORE_HOME_PORTS]: (context, data) => {
    context.commit(MT.SET_HOME_PORTS, data);
  },
  [AT.STORE_PTA_FTAS]: (context, data) => {
    context.commit(MT.SET_PTA_FTAS, data);
  },
  [AT.STORE_DRAW_BACK_RATES]: (context, data) => {
    context.commit(MT.SET_DRAW_BACK_RATES, data);
  },
  [AT.UPDATE_ESANCHIT_SUPPORTING_DOC]: (context, formData) => {
    return ImportExportService.updateSupportingDoc(formData)
      .then(response => {
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.GET_ESANCHIT_SUPPORTING_DOC]: (context, id) => {
    return ImportExportService.getSupportingDoc(id)
      .then(response => {
        if (response) {
          context.commit(MT.STORE_ESANCHIT_SUPPORTING_DOCS, response);
        }
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.ADD_ESANCHIT_SUPPORTING_DOC]: (context, formData) => {
    return ImportExportService.addSupportingDoc(formData)
      .then(response => {
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.DELETE_ESANCHIT_SUPPORTING_DOC]: (context, id) => {
    return ImportExportService.deleteSupportingDoc(id)
      .then(response => {
        return response;
      })
      .catch(error => Promise.reject(error.response));
  }
};
